import { render, staticRenderFns } from "./zoneStyle3.vue?vue&type=template&id=482f3d72&scoped=true&"
import script from "./zoneStyle3.vue?vue&type=script&lang=ts&"
export * from "./zoneStyle3.vue?vue&type=script&lang=ts&"
import style0 from "./zoneStyle3.vue?vue&type=style&index=0&id=482f3d72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f3d72",
  null
  
)

export default component.exports